"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMenu = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../helpers");
const getGroupIdArray_1 = require("./helpers/getGroupIdArray");
const NavigationMenu_styles_1 = require("./NavigationMenu.styles");
const NavigationMenuItem_1 = require("./components/NavigationMenuItem/NavigationMenuItem");
const NavigationMenuTitle_1 = require("./components/NavigationMenuTitle/NavigationMenuTitle");
exports.NavigationMenu = (0, helpers_1.createUIElement)('NavigationMenu', (_a, ref) => {
    var { className, width = 'auto', groups = [], items = [], renderHeader, renderFooter, triangleColor, onKeyDown, onKeyUp, onKeyPress, style, hideBorder = false, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "width", "groups", "items", "renderHeader", "renderFooter", "triangleColor", "onKeyDown", "onKeyUp", "onKeyPress", "style", "hideBorder", 'data-selector-id']);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'navigation', [initialDataSelectorId]);
    const groupIdArray = (0, react_1.useMemo)(() => (0, getGroupIdArray_1.getGroupIdArray)(groups), [groups]);
    const renderItems = (0, react_1.useCallback)((items) => (react_1.default.createElement(react_1.default.Fragment, null, items === null || items === void 0 ? void 0 : items.map(({ id, icon, title, active, onClick, url }) => (react_1.default.createElement(react_1.default.Fragment, { key: id || Math.random().toString(16) },
        react_1.default.createElement(NavigationMenuItem_1.NavigationMenuItem, { icon: icon, title: title, active: active, hideBorder: hideBorder, triangleColor: triangleColor, onClick: onClick, url: url })))))), [hideBorder, triangleColor]);
    return (react_1.default.createElement(NavigationMenu_styles_1.StyledNavigationMenu, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, width: width, hideBorder: hideBorder, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-NavigationMenu ', className) }),
        renderHeader && renderHeader(),
        items && (react_1.default.createElement(NavigationMenu_styles_1.StyledNavigationMenuSection, null,
            renderItems((items === null || items === void 0 ? void 0 : items.filter(({ groupId }) => !groupId || groupIdArray.indexOf(groupId) === -1)) || []), groups === null || groups === void 0 ? void 0 :
            groups.map(({ id, title }) => {
                const itemsByGroup = items === null || items === void 0 ? void 0 : items.filter((item) => item.groupId === id);
                return itemsByGroup.length ? (react_1.default.createElement(NavigationMenu_styles_1.StyledNavigationMenuGroup, { "data-selector-id": "navigation-group", key: id || Math.random().toString(16) },
                    react_1.default.createElement(NavigationMenuTitle_1.NavigationMenuTitle, null, title),
                    renderItems(itemsByGroup))) : null;
            }))),
        renderFooter && renderFooter()));
});
//# sourceMappingURL=NavigationMenu.js.map